<template>
  <div class="content-block">
    <div class="asd-form">
      <label class="required">{{ $t('common.name') }}</label>
      <input v-model="data.name"
             type="text"
             class="asd-input"
             required="required"
      >
      <label>Vlastnosti</label>
      <Multiselect
        v-model="data.propertyType"
        v-help.mouse="'Tímto výběrem se nedá určit pořadí vlastnosti v typu.|Pořadí vždy závisí na pořadí vlastností nastavene v editaci vlastností'"
        label="name"
        trackBy="key"
        :options="$store.getters.propertyTypes"
        :max="-1"
      ></Multiselect>
      <div v-if="propertyWarnings.length">
        <div v-for="(w, i) in propertyWarnings" :key="i"
             class="alert alert-danger"
             role="alert"
        >
          <h4 class="alert-heading">
            Nekompatibilní vlastnosti - {{ w.entities.join(', ') }}
          </h4>
          <p v-html="w.message"></p>
        </div>
      </div>

      <template v-if="entityStateProperties.length > 0">
        <label>Stavy pro tento typ úkolu</label>
        <AssignStatesTable
          v-model="data.settings.graphs"
          :properties="entityStateProperties"
        ></AssignStatesTable>
      </template>
      <FormControls v-if="data.validUntil === null">
        <button class="asd-btn-delete" @click="disableTaskType()">
          Smazat
        </button>
        <button v-if="taskTypeId !== null"
                v-help.mouse="'Aktuální hodnoty uloží jako nový typ úkoli.|Původní typ úkolu nebude ovlivněn.'"
                class="asd-btn-confirm"
                @click="duplicate()"
        >
          Uložit jako nový
        </button>
        <button v-if="taskTypeId !== null" class="asd-btn-confirm" @click="save()">
          Uložit
        </button>
        <button v-if="taskTypeId === null" class="asd-btn-confirm" @click="create()">
          Vytvořit
        </button>
      </FormControls>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import Multiselect from 'CORE/components/utilities/vue-multiselect-ext'
import FormControls from 'CORE/components/form/controls'
import { currentTimestamp } from 'CORE/utils/date'
import Vue from 'vue'
import AssignStatesTable from 'CORE/components/form/assign-states-table'
import EventBus from 'CORE/bus'

export default {
    name: 'TaskTypeForm',
    components: {
        FormControls,
        Multiselect,
        AssignStatesTable,
    },
    props: {
        taskTypeId: {
            type: String,
            required: false,
            default: _ => null,
        },
    },
    data: function() {
        return {
            data: {},
        }
    },
    computed: {
        entityStateProperties() {
            return _.filter(this.data.propertyType, pt => pt.type === 'ENTITY_STATE')
        },
        propertyWarnings() {
            const warnings = []
            const multipleEntityState = _.filter(this.data.propertyType, pt => _.get(pt, 'settings.systags.entityState', false))
            if (_.size(multipleEntityState) > 1) {
                warnings.push({
                    message: `Máte vybranou více než jednu vlastnost která má systémovou funkcionalitu "Stav".
                    Takovéto nastavení může vyůstit v neočekávané chování protože systém neví podle které vlastnosti stav úkolu určit.
                    Odeberte entity a nechte pouze jednu nebo jednu z entit odznačte v nastavení jako "Stav"`,
                    entities: _.map(multipleEntityState, pt => _.get(pt, 'name')),
                })
            }
            return warnings
        },
    },
    created() {
        if (this.taskTypeId === null) {
            this.data = {
                id: this.$uuid.v4(),
                name: null,
                propertyType: _.filter(this.$store.getters.propertyTypes, pt => _.get(pt, 'defaultTask', false)),
                settings: {},
                validUntil: null,
            }
        } else {
            this.data = this.$store.getters.taskTypeById(this.taskTypeId)
        }
        if (!_.isPlainObject(this.data.settings)) {
            this.$set(this.data, 'settings', {})
        }
        if (!_.isPlainObject(this.data.settings.graphs)) {
            this.$set(this.data.settings, 'graphs', {})
        }
        console.assert(
            _.isString(_.get(this.data, 'id')),
            'Invalid ID after data creation (not existing TaskType or invalid UUID creation)'
        )
    },
    methods: {
        async disableTaskType() {
            try {
                this.$set(this.data, 'validUntil', currentTimestamp())
                await this.$store.dispatch('updateTaskType', this.data)
                await this.$store.dispatch('taskTypesLoad')
                EventBus.$emit('FLASH_OK', { message: 'Uloženo' })
                this.$emit('done')
            } catch (e) {
                EventBus.$emit('FLASH_ERROR', e)
            }
        },
        async save() {
            try {
                await this.$store.dispatch('updateTaskType', this.data)
                await this.$store.dispatch('taskTypesLoad')
                EventBus.$emit('FLASH_OK', { message: 'Uloženo' })
                this.$emit('done')
            } catch (e) {
                EventBus.$emit('FLASH_ERROR', e)
            }
        },
        async create() {
            try {
                await this.$store.dispatch('createTaskType', this.data)
                await this.$store.dispatch('taskTypesLoad')
                EventBus.$emit('FLASH_OK', { message: 'Uloženo' })
                this.$emit('done')
            } catch (e) {
                EventBus.$emit('FLASH_ERROR', e)
            }
        },
        async duplicate() {
            Vue.set(this.data, 'id', this.$uuid.v4())
            this.data.name = `${this.data.name} - kopie`
            await this.create()
        },
    },
}
</script>
